export const contact = (type, data) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post(`/api/${type}`, data, {
        timeout: 3000,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-TOKEN': document
            .querySelector('meta[name="csrf-token"]')
            .getAttribute('content'),
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        if (error.response.status == 422) {
          reject(error.response.data.errors);
        }
        reject(error);
      });
  });
};
